// extracted by mini-css-extract-plugin
export var aboveInput = "_o0-0";
export var actionButton = "_o0-5";
export var actionButtonContainer = "_o0-1";
export var actionIcon = "_o0-6";
export var aiInfoContainer = "_o0-2";
export var attachmentWrapper = "_o0-7";
export var bold = "_o0-3";
export var checkIcon = "_o0-8";
export var clickingRecipientBar = "_o0-11";
export var commentThreadSwitch = "_o0-a";
export var draftImage = "_o0-b";
export var draftImageContainer = "_o0-c";
export var draftImages = "_o0-e";
export var editButton = "_o0-g";
export var editor = "_o0-f";
export var editorContainer = "_o0-y";
export var editorErrorTooltipWrapper = "_o0-9";
export var headerDivider = "_o0-h";
export var icon = "_o0-i";
export var info = "_o0-j";
export var internal = "_o0-n";
export var internalDivider = "_o0-k";
export var internalMessage = "_o0-l";
export var messageInputCard = "_o0-m";
export var messageInputForm = "_o0-o";
export var messageInputFormInternal = "_o0-p";
export var options = "_o0-q";
export var publicMessageCustomer = "_o0-s";
export var publicMessageMerchant = "_o0-r";
export var removeImageButton = "_o0-d";
export var replyButtons = "_o0-t";
export var showSignatureButton = "_o0-u";
export var spinner = "_o0-v";
export var verticalButtonDivider = "_o0-4";
export var visibilitySelector = "_o0-w";
export var warning = "_o0-x";
export var wrappingText = "_o0-z";
export var writingInternalNoteTopBorder = "_o0-10";